import React, { useMemo } from 'react';
import { Pressable } from 'react-native';
import MoreOptionsButton from 'src/components/10-atoms/dropdown-menu/MoreOptionsButton';
import DeleteIcon from 'src/components/10-atoms/icons/DeleteIcon';
import EditIcon from 'src/components/10-atoms/icons/EditIcon';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import HistoryIcon from 'src/components/10-atoms/icons/HistoryIcon';
import Row from 'src/components/10-atoms/layout/Row';
import Typography from 'src/components/10-atoms/typography/Typography';
import { TypographyFontWeight } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import useI18n from 'src/modules/translations/hooks/useI18n';
const TabItem = ({ tab, isActive, editable = true, onTabChange, onEditTab, onDeleteTab, onViewHistory, }) => {
    const [{ theme, styles }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const menuOptions = useMemo(() => {
        const options = [];
        if (editable && onEditTab) {
            options.push({
                Icon: EditIcon,
                title: translate('Edit'),
                onPress: () => onEditTab(tab),
            });
        }
        if (editable && onDeleteTab) {
            options.push({
                Icon: DeleteIcon,
                title: translate('Delete'),
                onPress: () => onDeleteTab(tab),
            });
        }
        if (onViewHistory) {
            options.push({
                Icon: HistoryIcon,
                title: translate('View history'),
                onPress: () => onViewHistory(tab),
            });
        }
        return options;
    }, [onEditTab, onDeleteTab, onViewHistory, translate, tab, editable]);
    return (React.createElement(Pressable, { onPress: () => {
            onTabChange(tab.id);
        } },
        React.createElement(Row, { style: [styles.tab, isActive && styles.activeTab], xAxis: "space-between", yAxis: "center" },
            React.createElement(Typography, { flex: true, fontWeight: isActive ? TypographyFontWeight.MEDIUM : TypographyFontWeight.REGULAR }, tab.data.title),
            menuOptions.length > 0 && (React.createElement(Pressable, { onPress: (e) => e?.stopPropagation() },
                React.createElement(MoreOptionsButton, { options: menuOptions, renderButton: () => (React.createElement(FeatherIcon, { name: "more-vertical", size: theme.iconSize.sm, color: theme.palette.icon.primary })) }))))));
};
const stylesGenerator = createThemedStyle(({ theme, deviceType }) => ({
    tab: deviceType.isPhone ? {
        paddingLeft: theme.spacing.standard.md,
        paddingRight: theme.spacing.standard.sm,
        paddingVertical: theme.spacing.standard.xs,
        borderRadius: theme.borderRadius.standard.xxl,
        overflow: 'hidden',
        marginHorizontal: theme.spacing.page,
    } : {
        borderTopRightRadius: theme.borderRadius.standard.xxl,
        borderBottomRightRadius: theme.borderRadius.standard.xxl,
        overflow: 'hidden',
        paddingLeft: theme.spacing.page,
        paddingRight: theme.spacing.standard.xs,
        marginRight: theme.spacing.page,
        paddingVertical: theme.spacing.standard.xs,
    },
    activeTab: {
        backgroundColor: theme.palette.primary.subtle,
    },
}));
export default TabItem;
